import React from 'react';

import * as RequestAccessActions from 'auth/RequestAccessActions';
import notifications from 'notifications';
import Link from 'ui-library/Link';

export default function RequestAccessLink({resourceId}: {resourceId: string}): JSX.Element {
  return (
    <Link
      onClick={() => {
        RequestAccessActions.requestAccess(resourceId);
        notifications.success('Access requested.');
      }}
    >
      Request Access
    </Link>
  );
}
